(function() {
  $(document).ready(function() {
    const body = document.querySelector('body');
    const productsArray = document.querySelectorAll('.product__wrapper');
    const header = document.querySelector('.header');
    const collectionList = document.querySelector('.collectionFullpage__list');
    const collectionSubcategories = document.querySelector('.collectionSubcategories');
    const noticeList = document.querySelector('.noticeList');
    const collectionHeader = document.querySelector('.collectionFullpage__titleWrapper');
    const wrapperInner = document.querySelector('.collectionFullpage__wrapperInner');
    const headerBackground = document.querySelector('.header--background');
    const headerWrapper = document.querySelector('.header__wrapper');
    const subcategories = document.querySelector('.collectionFullpage__subcategories');

    body.classList.add('body--active');

    productsArray.forEach((product, i) => {
      const delayTime = i / 10;

      product.style.opacity = 1;
      product.style.transitionDelay = `${delayTime}s`;
      product.classList.add('product__wrapper--active');
    });

    if (!collectionSubcategories) {
      const titleWrapper = document.querySelector('.collectionFullpage__titleWrapper');

      titleWrapper.classList.add('collectionFullpage__titleWrapper--noSubcategories');
    }

    function toggleHeaderBackgroud() {
      if (collectionList.getBoundingClientRect().top - noticeList.offsetHeight <= 0) {
        wrapperInner.classList.add('collectionFullpage__wrapperInner--sticky');
        headerBackground.classList.add('header--background-long');
      } else {
        headerBackground.classList.remove('header--background-long');
        wrapperInner.classList.remove('collectionFullpage__wrapperInner--sticky');
      }
    }

    if (window.innerWidth >= 769) {
      if (collectionList) {
        window.addEventListener('scroll', toggleHeader);
      }

      function toggleHeader() {
        if (collectionList.getBoundingClientRect().top - noticeList.offsetHeight <= 0) {
          header.classList.remove('header--animation');
          collectionHeader.classList.remove('collectionFullpage__titleWrapper--hidden');

          if (collectionSubcategories) {
            collectionSubcategories.classList.remove('collectionSubcategories--hidden');
          }
        } else if (collectionList.getBoundingClientRect().top - header.offsetHeight - noticeList.offsetHeight <= 0) {
          header.classList.add('header--animation');
          collectionHeader.classList.add('collectionFullpage__titleWrapper--hidden');

          if (collectionSubcategories) {
            collectionSubcategories.classList.add('collectionSubcategories--hidden');
          }
        } else {
          header.classList.remove('header--animation');
          collectionHeader.classList.remove('collectionFullpage__titleWrapper--hidden');

          if (collectionSubcategories) {
            collectionSubcategories.classList.remove('collectionSubcategories--hidden');
          }
        }
      }
    }

    document.documentElement.style.setProperty('--header-background-position', `${header.offsetHeight}px`);

    addEventListener("resize", () => {
      document.documentElement.style.setProperty('--header-background-position', `${document.querySelector('.header').offsetHeight}px`);
    });

    window.addEventListener('scroll', toggleHeaderBackgroud);
  });
})();
